import React, { useState } from 'react';
import { 
  FileText, 
  Download,
  Plus,
  Eye,
  Filter,
  Calendar,
  User,
  Star,
  CheckCircle,
  AlertTriangle,
  Clock,
  MessageSquare,
  Printer,
  Mail,
  Search
} from 'lucide-react';
import Card from '../../components/Card';

const InstallationReports = () => {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedReport, setSelectedReport] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [dateRange, setDateRange] = useState('thisMonth');

  // Rapoarte și PV-uri instalare
  const reports = [
    {
      id: 'PV-2024-045',
      type: 'completion',
      client: 'Familia Popescu',
      address: 'Str. Florilor 25, Sector 2, București',
      project: 'proiecte epoxidic Triple Glazing',
      installationTeam: 'Echipa Ștefan',
      technician: 'Ștefan Georgescu',
      date: '2025-01-08',
      duration: '2 zile',
      status: 'completed',
      rating: 5,
      value: 8500,
      items: [
        { name: 'proiect epoxidic 120x140cm', quantity: 3, installed: 3 },
        { name: 'proiect epoxidic 80x120cm', quantity: 2, installed: 2 },
        { name: 'Kit etanșare premium', quantity: 1, installed: 1 }
      ],
      customerFeedback: {
        rating: 5,
        comment: 'Echipa foarte profesionistă, instalare rapidă și curată. Recomand cu încredere!',
        aspects: {
          punctuality: 5,
          professionalism: 5,
          quality: 5,
          cleanliness: 4
        }
      },
      technicalNotes: 'Instalare fără probleme. Toate proiectele au trecut testele de etanșeitate.',
      images: 8,
      warranty: '10 ani',
      nextService: '2025-07-08'
    },
    {
      id: 'PV-2024-046',
      type: 'completion',
      client: 'Hotel Continental Plaza',
      address: 'Calea Victoriei 78, Sector 1, București',
      project: 'lucrări de Intrare Securizate',
      installationTeam: 'Echipa Eusebiu',
      technician: 'Eusebiu Marinescu',
      date: '2025-01-09',
      duration: '4 zile',
      status: 'completed',
      rating: 4,
      value: 15600,
      items: [
        { name: 'pardoseală heavy duty clasa 4', quantity: 8, installed: 8 },
        { name: 'Sistem acces carduri', quantity: 2, installed: 2 },
        { name: 'Camere supraveghere', quantity: 4, installed: 4 }
      ],
      customerFeedback: {
        rating: 4,
        comment: 'Lucrare profesională, echipament de calitate. O mică întârziere la început.',
        aspects: {
          punctuality: 3,
          professionalism: 5,
          quality: 5,
          cleanliness: 4
        }
      },
      technicalNotes: 'Întârziere 1 zi din cauza livrării sistemului de acces. Instalare relucrărită.',
      images: 12,
      warranty: '15 ani',
      nextService: '2025-07-09'
    },
    {
      id: 'RAPORT-2024-018',
      type: 'incident',
      client: 'SC Construct Nord SRL',
      address: 'Bd. Expozitiei 15A, Sector 1, București',
      project: 'Ansamblu Rezidențial Primăverii',
      installationTeam: 'Echipa Mixt',
      technician: 'Beniamin Stoica',
      date: '2025-01-06',
      duration: 'Întrerupt',
      status: 'pending',
      rating: null,
      value: 89000,
      items: [
        { name: 'proiecte epoxidic 140x160cm', quantity: 15, installed: 8 },
        { name: 'proiecte epoxidic 100x120cm', quantity: 30, installed: 15 }
      ],
      incident: {
        type: 'Material Defect',
        description: 'Probleme cu etanșarea la 3 proiecte din primul lot. Înlocuire necesară.',
        severity: 'medium',
        resolution: 'În curs - comandă materiale noi',
        estimatedResolution: '2025-01-12'
      },
      technicalNotes: 'Defect fabricație la profilele din lotul L-2024-156. Supplier contactat.',
      images: 6,
      warranty: 'Suspendată până la rezolvare'
    },
    {
      id: 'PV-2024-047',
      type: 'inspection',
      client: 'Familia Ionescu',
      address: 'Str. Mihai Bravu 145, Sector 2, București',
      project: 'proiecte Aluminiu Premium',
      installationTeam: 'Echipa Ștefan',
      technician: 'Ștefan Georgescu',
      date: '2025-01-10',
      duration: '1 zi',
      status: 'scheduled',
      rating: null,
      value: 12300,
      items: [
        { name: 'proiect aluminiu 150x180cm', quantity: 2, installed: 0 },
        { name: 'proiect aluminiu 120x140cm', quantity: 4, installed: 0 },
        { name: 'lucrare terasă aluminiu', quantity: 1, installed: 0 }
      ],
      inspection: {
        type: 'Pre-installation',
        checklist: [
          { item: 'Măsurători finale', status: 'pending' },
          { item: 'Verificare structură', status: 'pending' },
          { item: 'Pregătire spații', status: 'pending' },
          { item: 'Confirmare materiale', status: 'completed' }
        ]
      },
      technicalNotes: 'Programat pentru verificări finale înainte de instalare.',
      images: 0,
      warranty: 'N/A'
    },
    {
      id: 'PV-2024-048',
      type: 'warranty',
      client: 'Vila Baneasa Premium',
      address: 'Șos. București-Nord 15, Sector 1',
      project: 'Service Garanție proiecte',
      installationTeam: 'Echipa Support',
      technician: 'Beniamin Stoica',
      date: '2025-01-07',
      duration: '4 ore',
      status: 'completed',
      rating: 5,
      value: 0,
      items: [
        { name: 'Înlocuire mâner proiect', quantity: 1, installed: 1 },
        { name: 'Ajustare închidere', quantity: 3, installed: 3 },
        { name: 'Re-etanșare proiect baie', quantity: 1, installed: 1 }
      ],
      warranty: {
        originalInstallation: '2023-08-15',
        warrantyPeriod: '10 ani',
        issueType: 'Uzură normală',
        covered: true,
        cost: 0
      },
      customerFeedback: {
        rating: 5,
        comment: 'Rezolvare rapidă, fără costuri suplimentare. Mulțumesc pentru profesionalism!',
        aspects: {
          punctuality: 5,
          professionalism: 5,
          quality: 5,
          cleanliness: 5
        }
      },
      technicalNotes: 'Probleme minore de uzură. Service complet în garanție.',
      images: 4,
      nextService: 'La cerere'
    }
  ];

  const reportTypes = [
    { id: 'all', name: 'Toate', color: 'text-gray-600' },
    { id: 'completion', name: 'PV Finalizare', color: 'text-green-600' },
    { id: 'incident', name: 'Rapoarte Incident', color: 'text-red-600' },
    { id: 'inspection', name: 'Inspecții', color: 'text-blue-600' },
    { id: 'warranty', name: 'Service Garanție', color: 'text-yellow-600' },
    { id: 'quality', name: 'Control Calitate', color: 'text-purple-600' }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'bg-green-100 text-green-800 border-green-200';
      case 'in_progress': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'pending': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'scheduled': return 'bg-gray-100 text-gray-800 border-gray-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed': return 'Finalizat';
      case 'in_progress': return 'În Progres';
      case 'pending': return 'În Așteptare';
      case 'scheduled': return 'Programat';
      default: return 'Necunoscut';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'completion': return CheckCircle;
      case 'incident': return AlertTriangle;
      case 'inspection': return Eye;
      case 'warranty': return Star;
      case 'quality': return FileText;
      default: return FileText;
    }
  };

  const filteredReports = reports.filter(report => {
    const matchesType = selectedFilter === 'all' || report.type === selectedFilter;
    const matchesSearch = report.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         report.project.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         report.technician.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesType && matchesSearch;
  });

  // Statistics
  const totalReports = reports.length;
  const completedReports = reports.filter(r => r.status === 'completed').length;
  const pendingReports = reports.filter(r => r.status === 'pending').length;
  const avgRating = reports.filter(r => r.rating).reduce((sum, r) => sum + r.rating, 0) / reports.filter(r => r.rating).length || 0;

  const ReportModal = ({ report, onClose }) => {
    if (!report) return null;
    
    const TypeIcon = getTypeIcon(report.type);

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-6xl m-4 max-h-screen overflow-y-auto">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <TypeIcon className="w-6 h-6 text-primary-600" />
              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  {report.id} - {report.client}
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  {report.project}
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-xl font-bold"
            >
              ×
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-6">
              {/* Project Details */}
              <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">
                  Detalii Proiect
                </h4>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="text-gray-600 dark:text-gray-300">Client:</span>
                    <p className="font-medium text-gray-900 dark:text-white">{report.client}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 dark:text-gray-300">Adresă:</span>
                    <p className="font-medium text-gray-900 dark:text-white">{report.address}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 dark:text-gray-300">Echipă:</span>
                    <p className="font-medium text-gray-900 dark:text-white">{report.installationTeam}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 dark:text-gray-300">Tehnician:</span>
                    <p className="font-medium text-gray-900 dark:text-white">{report.technician}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 dark:text-gray-300">Data:</span>
                    <p className="font-medium text-gray-900 dark:text-white">
                      {new Date(report.date).toLocaleDateString('ro-RO')}
                    </p>
                  </div>
                  <div>
                    <span className="text-gray-600 dark:text-gray-300">Durată:</span>
                    <p className="font-medium text-gray-900 dark:text-white">{report.duration}</p>
                  </div>
                </div>
              </div>

              {/* Items List */}
              <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">
                  Elemente Instalate
                </h4>
                <div className="space-y-2">
                  {report.items.map((item, index) => (
                    <div key={index} className="flex justify-between items-center bg-white dark:bg-gray-600 p-3 rounded">
                      <div>
                        <span className="font-medium text-gray-900 dark:text-white">
                          {item.name}
                        </span>
                      </div>
                      <div className="text-sm">
                        <span className={`font-medium ${
                          item.installed === item.quantity ? 'text-green-600' : 'text-yellow-600'
                        }`}>
                          {item.installed}/{item.quantity}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Customer Feedback */}
              {report.customerFeedback && (
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-3">
                    Feedback Client
                  </h4>
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <span className="text-gray-600 dark:text-gray-300 text-sm">Rating:</span>
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <Star 
                            key={i} 
                            className={`w-4 h-4 ${
                              i < report.customerFeedback.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
                            }`} 
                          />
                        ))}
                      </div>
                      <span className="font-medium text-gray-900 dark:text-white">
                        {report.customerFeedback.rating}/5
                      </span>
                    </div>
                    {report.customerFeedback.comment && (
                      <div className="bg-white dark:bg-gray-600 p-3 rounded">
                        <MessageSquare className="w-4 h-4 text-gray-400 mb-2" />
                        <p className="text-sm text-gray-600 dark:text-gray-300 italic">
                          "{report.customerFeedback.comment}"
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Technical Notes */}
              {report.technicalNotes && (
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-3">
                    Note Tehnice
                  </h4>
                  <p className="text-gray-600 dark:text-gray-300 text-sm">
                    {report.technicalNotes}
                  </p>
                </div>
              )}

              {/* Incident Details */}
              {report.incident && (
                <div className="bg-red-50 dark:bg-red-900/20 p-4 rounded-lg border border-red-200 dark:border-red-800">
                  <h4 className="font-semibold text-red-800 dark:text-red-300 mb-3 flex items-center">
                    <AlertTriangle className="w-4 h-4 mr-2" />
                    Detalii Incident
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div>
                      <span className="text-red-700 dark:text-red-300">Tip:</span>
                      <p className="font-medium text-red-900 dark:text-red-100">{report.incident.type}</p>
                    </div>
                    <div>
                      <span className="text-red-700 dark:text-red-300">Descriere:</span>
                      <p className="text-red-800 dark:text-red-200">{report.incident.description}</p>
                    </div>
                    <div>
                      <span className="text-red-700 dark:text-red-300">Rezolvare:</span>
                      <p className="text-red-800 dark:text-red-200">{report.incident.resolution}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              {/* Status */}
              <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">
                  Status
                </h4>
                <div className="space-y-2">
                  <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(report.status)}`}>
                    {getStatusText(report.status)}
                  </span>
                  {report.rating && (
                    <div className="flex items-center mt-2">
                      <span className="text-gray-600 dark:text-gray-300 text-sm mr-2">Rating:</span>
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <Star 
                            key={i} 
                            className={`w-4 h-4 ${
                              i < report.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
                            }`} 
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Value */}
              <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">
                  Valoare
                </h4>
                <div className="text-2xl font-bold text-primary-600">
                  {report.value > 0 ? `${report.value.toLocaleString('ro-RO')} €` : 'Gratuit'}
                </div>
                {report.warranty && (
                  <div className="mt-2 text-sm">
                    <span className="text-gray-600 dark:text-gray-300">Garanție:</span>
                    <p className="font-medium text-gray-900 dark:text-white">{report.warranty}</p>
                  </div>
                )}
              </div>

              {/* Images */}
              {report.images > 0 && (
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-3">
                    Documentație
                  </h4>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-600">
                      {report.images}
                    </div>
                    <div className="text-sm text-gray-600 dark:text-gray-300">
                      Fotografii
                    </div>
                    <button className="mt-2 text-sm text-blue-600 hover:text-blue-800">
                      Vezi Galerie
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg transition-colors"
            >
              Închide
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              <Download className="w-4 h-4" />
              Export PDF
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
              <Mail className="w-4 h-4" />
              Trimite Client
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-4">
          <FileText className="w-8 h-8 text-purple-600" />
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Rapoarte Instalare
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              PV-uri, feedback clienți și documentație proiecte OSIS
            </p>
          </div>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors">
          <Plus className="w-4 h-4" />
          Raport Nou
        </button>
      </div>

      {/* Filters and Search */}
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            placeholder="Caută rapoarte, clienți, tehnicieni..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </div>
        
        <div className="flex flex-wrap gap-2">
          {reportTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => setSelectedFilter(type.id)}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                selectedFilter === type.id
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              }`}
            >
              {type.name}
            </button>
          ))}
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-soft">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-2xl font-bold text-gray-900 dark:text-white">
                {totalReports}
              </div>
              <div className="text-gray-600 dark:text-gray-400 text-sm">
                Total Rapoarte
              </div>
            </div>
            <FileText className="w-8 h-8 text-purple-600" />
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-soft">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-2xl font-bold text-green-600">
                {completedReports}
              </div>
              <div className="text-gray-600 dark:text-gray-400 text-sm">
                Finalizate
              </div>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-soft">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-2xl font-bold text-yellow-600">
                {pendingReports}
              </div>
              <div className="text-gray-600 dark:text-gray-400 text-sm">
                În Așteptare
              </div>
            </div>
            <Clock className="w-8 h-8 text-yellow-600" />
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-soft">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-2xl font-bold text-primary-600">
                {avgRating.toFixed(1)}
              </div>
              <div className="text-gray-600 dark:text-gray-400 text-sm">
                Rating Mediu
              </div>
            </div>
            <Star className="w-8 h-8 text-primary-600" />
          </div>
        </div>
      </div>

      {/* Reports List */}
      <div className="space-y-4">
        {filteredReports.map((report) => {
          const TypeIcon = getTypeIcon(report.type);
          const reportType = reportTypes.find(t => t.id === report.type);
          
          return (
            <Card key={report.id} className="hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-start justify-between">
                  <div className="flex items-start gap-4 flex-1">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-primary-400 rounded-full flex items-center justify-center">
                      <TypeIcon className="w-6 h-6 text-white" />
                    </div>
                    
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-3 mb-2">
                        <h3 className="font-semibold text-gray-900 dark:text-white">
                          {report.id}
                        </h3>
                        <span className={`text-xs font-medium ${reportType?.color}`}>
                          {reportType?.name}
                        </span>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(report.status)}`}>
                          {getStatusText(report.status)}
                        </span>
                      </div>
                      
                      <div className="space-y-2">
                        <div>
                          <p className="font-medium text-gray-900 dark:text-white">
                            {report.client}
                          </p>
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            {report.project}
                          </p>
                        </div>
                        
                        <div className="flex items-center gap-4 text-sm text-gray-600 dark:text-gray-400">
                          <div className="flex items-center gap-1">
                            <User className="w-4 h-4" />
                            <span>{report.technician}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <Calendar className="w-4 h-4" />
                            <span>{new Date(report.date).toLocaleDateString('ro-RO')}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <Clock className="w-4 h-4" />
                            <span>{report.duration}</span>
                          </div>
                          {report.rating && (
                            <div className="flex items-center gap-1">
                              <Star className="w-4 h-4 text-yellow-400" />
                              <span>{report.rating}/5</span>
                            </div>
                          )}
                        </div>

                        {report.incident && (
                          <div className="bg-red-50 dark:bg-red-900/20 p-2 rounded flex items-center gap-2">
                            <AlertTriangle className="w-4 h-4 text-red-600" />
                            <span className="text-sm text-red-700 dark:text-red-300">
                              {report.incident.type}: {report.incident.description}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex flex-col items-end gap-3">
                    <div className="text-right">
                      <div className="font-bold text-primary-600">
                        {report.value > 0 ? `${report.value.toLocaleString('ro-RO')} €` : 'Gratuit'}
                      </div>
                      {report.images > 0 && (
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          {report.images} fotografii
                        </div>
                      )}
                    </div>
                    
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => {
                          setSelectedReport(report);
                          setShowModal(true);
                        }}
                        className="flex items-center gap-1 px-3 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                      >
                        <Eye className="w-4 h-4" />
                        Detalii
                      </button>
                      <button className="flex items-center gap-1 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                        <Download className="w-4 h-4" />
                        Export
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
      </div>

      {/* Report Modal */}
      {showModal && (
        <ReportModal
          report={selectedReport}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default InstallationReports;